import { useEffect, useState } from 'react';
import { adminAPI } from '../services/api';

export const useAdminProductSearch = ({ term, lowMargin, unpublished = false, seoGrade = '', sort = '', category = '', subcategory = '', vehicle = {}, noCompat = false, fuel = '', refreshKey, limit = 50 }) => {
  const vehicleKey = `${vehicle.brand || ''}|${vehicle.model || ''}|${vehicle.engine || ''}`;
  const [page, setPage] = useState(1);
  const [data, setData] = useState({ items: [], total: 0, pages: 1 });
  const [loading, setLoading] = useState(false);
  const [debounced, setDebounced] = useState(term);

  useEffect(() => {
    const t = setTimeout(() => setDebounced(term), 300);
    return () => clearTimeout(t);
  }, [term]);

  useEffect(() => { setPage(1); }, [debounced, lowMargin, unpublished, seoGrade, sort, category, subcategory, vehicleKey, noCompat, fuel]);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    adminAPI.searchProducts({ q: debounced, page, limit, lowMargin, unpublished, seoGrade, sort, category, subcategory, vehicle, noCompat, fuel })
      .then(d => { if (!cancelled) setData(d); })
      .catch(() => { if (!cancelled) setData({ items: [], total: 0, pages: 1 }); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [debounced, page, limit, lowMargin, unpublished, seoGrade, sort, category, subcategory, vehicleKey, noCompat, fuel, refreshKey]); // eslint-disable-line react-hooks/exhaustive-deps

  return { ...data, page, setPage, loading, searching: debounced !== term };
};
